module.exports = __webpack_public_path__ + "static/img/kjhs-bg.9855f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/kjhs-bg.png
// module id = 3Dk8
// module chunks = 96